/* src/app/components/faq-sidebar/faq-sidebar.component.scss */
.faq-sidebar-container {
  width: 420px;
  background: #f6f6f6;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  animation: slideInSidebar 0.2s;
  height: 100%;
}
.header-preview {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-bottom: 1px solid #eee;
}
.faq-content {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 1rem;
  min-height: 0;
  max-height: 100%;
  padding-bottom: 92px;
}
.faq-header {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
  display: flex;
  align-items: center;
  padding: 5px 5px 0px 20px;
  border-bottom: 1px solid #eee;
}
.faq-header-icon {
  margin-right: 12px;
  display: flex;
  align-items: center;
}
.faq-header-title {
  color: var(--Escala-de-grises-NEGRO-TEXTO, #000);
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  flex: 1;
}
.faq-header .close ion-icon {
  color: #000;
  fill: #000;
  width: 24px;
  height: 24px;
}
@keyframes slideInSidebar {
  from {
    right: -400px;
  }
  to {
    right: 0;
  }
}
.faq-section-type {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
}
.faq-section-title {
  display: flex;
  height: 28px;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  color: var(--copyfly-es-star-dust, #939392);
  text-align: center;
  font-family: Raleway, sans-serif;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 35px;
  margin-top: -20px;
}
.faq-categories-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: stretch;
}
.faq-category-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  padding: 15px;
  border-radius: 15px;
  border: 1px solid #949494;
  background: var(--Blanco-y-negro-GRIS-1, #f6f6f6);
  min-width: 120px;
  transition: box-shadow 0.2s;
  justify-content: flex-start;
  text-align: left;
}
.faq-category-item:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.faq-category-icon {
  width: 28px;
  height: 28px;
}
.faq-category-desc {
  font-family: Raleway, sans-serif;
  font-size: 18px;
  color: #000;
  font-weight: 500;
}
.faq-category-desc {
  color: var(--copyfly-es-black, #000);
  font-family: "League Spartan", sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.faq-header-separator {
  width: 100%;
  height: 2px;
  background: #000;
  position: relative;
}
.faq-section-block {
  margin-top: 32px;
}
.faq-section-header-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
}
.faq-section-header-icon {
  width: 30px;
  height: 30px;
}
.faq-section-header-title {
  color: #000;
  font-family: "League Spartan", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.faq-section-header {
  color: #000;
  font-family: "League Spartan", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 16px;
}
.faq-question-list {
  display: flex;
  flex-direction: column;
}
.faq-question-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 5px 10px;
  border-radius: 15px;
  background: #fff;
  font-family: "League Spartan", sans-serif;
  font-size: 20px;
  color: #000;
  font-weight: 400;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  margin-bottom: 12px;
  transition: box-shadow 0.2s;
}
.faq-question-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.faq-question-item:hover {
  background: var(--Blanco-y-negro-GRIS-1, #f6f6f6);
}
.faq-question-plus,
.faq-question-arrow {
  cursor: pointer;
}
.faq-answer img {
  cursor: pointer;
}
.faq-question-plus {
  font-size: 38px;
  font-weight: 700;
  color: #000;
  margin-left: 20px;
  line-height: 1;
  transition: transform 0.2s;
}
.faq-question-plus.open {
  transform: rotate(45deg);
}
.faq-question-arrow {
  margin-left: auto;
  transition: transform 0.2s;
}
.faq-question-arrow.open {
  transform: rotate(180deg);
}
.faq-answer {
  width: 100%;
  margin-top: 12px;
  background: #fff;
  border-radius: 10px;
  padding: 12px 10px;
  color: #333;
  box-shadow: none;
  font-size: 18px;
}
.faq-category-separator {
  height: 1px;
  align-self: stretch;
  background: #949494;
  margin: 24px 0 16px 0;
  width: 100%;
}
/*# sourceMappingURL=faq-sidebar.component-BNKMCQXV.css.map */
